import { Injectable, inject } from '@angular/core';

import { StringInterpolationPipe } from '@frontend/sports/common/core/utils/string-interpolation';
import { NativePriceFormatterService } from '@frontend/sports/odds/feature/native-price';
import { Observable, of } from 'rxjs';

import { BetPlacementError } from '../../../errors/bet-placement-error';
import { BetslipError } from '../../../errors/betslip-error';
import { UnderMinimumCompulsoryOdds } from '../../../errors/user/under-minimum-compulsory-odds';
import { ErrorMessageCurrencySymbolFormatService } from '../error-message-currency-symbol-format.service';
import { MessageFormatter } from './message-formatter';

@Injectable()
export class UnderMinimumCompulsoryOddsMessageFormatter extends MessageFormatter<BetPlacementError> {
    private priceFormatter = inject(NativePriceFormatterService);
    private interpolationPipe = inject(StringInterpolationPipe);
    private errorMessageCurrencySymbolFormatService = inject(ErrorMessageCurrencySymbolFormatService);

    format(error: UnderMinimumCompulsoryOdds): Observable<string> {
        const errorMessage = this.replaceFormattedOdds(error.errorMessage);

        return of(this.errorMessageCurrencySymbolFormatService.updateCurrencyPlaceholders(errorMessage));
    }

    replaceFormattedOdds(input: string): string {
        const regex = /(.*{{\s?oddsformat\s?}})(.*)/g;

        const match = regex.exec(input);
        if (!match) {
            return input;
        }

        const value = parseFloat(match[2].replace(',', '.'));
        if (isNaN(value)) {
            return input;
        }

        return this.formatWithParams(match[1], { oddsformat: value });
    }

    formatWithParams(message: string, odds: Record<string, number>): string {
        const formattedOdds: Record<string, string> = {};
        Object.keys(odds).forEach((key) => (formattedOdds[key] = this.priceFormatter.format(odds[key])));

        return this.interpolationPipe.transform(message, formattedOdds);
    }

    canHandle(error: BetslipError): boolean {
        return error instanceof UnderMinimumCompulsoryOdds;
    }
}
